<template>
  <validation-observer
    v-if="shouldQuestionRender && isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      :id="questionId || 'vehicle-tracking-device'"
      v-bind="observer"
      :validated="formObserver.validated && observer.failed"
    >
      <form-row
        :label="title || `Does the ${productName} have a tagging device/secure markings?`"
        :error="formObserver.validated && observer.failed"
      >
        <template #helpText>
          <div class="d-flex align-start">
            <v-icon
              class="mr-4"
              color="primary"
            >
              mdi-credit-card-outline
            </v-icon>
            <p>
              <strong>Price sensitive question</strong><br>
              {{ helpText || 'In the event of theft, these provide a way to identify and to retrieve your bike. Some insurance providers may ask for proof of this and may provide a discount.' }}
            </p>
          </div>
        </template>
        <validation-provider
          v-slot="{ failed }"
          :name="questionId"
          :vid="`${stepId}_${questionId}`"
          rules="required"
        >
          <radio
            v-model="vehicleTrackingDeviceModel"
            :name="`${stepId}-${questionId}`"
            :items="constants.YES_NO"
            :error="failed"
            :data-test="snakeCase(questionFields.vehicleTrackingDevice)"
          />
        </validation-provider>
      </form-row>
      <form-row
        v-if="vehicleTrackingDeviceModel"
        :error="formObserver.validated && observer.failed"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_${questionId}`"
          :name="questionId"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.vehicleTrackingDevice"
            :items="vehicleTrackingDeviceOptions"
            :error-messages="errors"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select tagging device / secure markings type', isMobile)"
            :data-test="`${snakeCase(questionFields.vehicleTrackingDevice)}_type`"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import { omit } from 'lodash';
import QuestionBase from './Base';

export default {
  name: 'question-vehicle-tracking-device',
  extends: QuestionBase,
  data () {
    return {
      fields: ['vehicleTrackingDevice'],
    };
  },
  computed: {
    vehicleTrackingDeviceModel: {
      get () {
        const current = this.questionData.vehicleTrackingDevice;
        if (current === null) return null;
        if (current === 'N') return false;
        return true;
      },
      set (val) {
        this.questionData.vehicleTrackingDevice = val ? '' : 'N';
      },
    },
    vehicleTrackingDeviceOptions () {
      return this.helpers.createOptions({ source: omit(this.constants.VEHICLE_TRACKING_DEVICE, ['N']) });
    },
  },
};
</script>
